import { type AppDispatch, type AppThunk, type RootState } from "../../../../Application/globaltypes/redux";
import { type EntityType } from "../../../../Library/Flows/Designer/types";
import { packContentTypeSelectSelector } from "../selectors";
import { fetchBegin, fetchFailure, fetchSuccess } from "../slices/packContentTabItemsToDropSlice";
import {
  fetchAssessmentsItemsV2,
  fetchCampaignItemsV2,
  fetchEmailsItemsV2,
  fetchEmbeddedVideoItemsV2,
  fetchEventsItemsV2,
  fetchFlowsItemsV2,
  fetchMessagesItemsV2,
  fetchPdfsItemsV2,
  fetchSurveyItemsV2,
  fetchVideoItemsV2,
  fetchLinkItemsV2,
  type ItemsToDropPayload,
} from "../../../../../utils/fetchItemsToDrop";

export const fetchItemsToDropV2 = (payload: ItemsToDropPayload) => {
  return async (dispatch: AppDispatch, getState: () => RootState) => {
    const map: { [key in EntityType]?: () => AppThunk } = {
      Video: () => fetchVideoItemsV2(payload, fetchBegin, fetchSuccess, fetchFailure, packContentTypeSelectSelector),
      Survey: () => fetchSurveyItemsV2(payload, fetchSuccess, fetchFailure, packContentTypeSelectSelector),
      Assessment: () =>
        fetchAssessmentsItemsV2(payload, fetchBegin, fetchSuccess, fetchFailure, packContentTypeSelectSelector),
      Flow: () => fetchFlowsItemsV2(payload, fetchBegin, fetchSuccess, fetchFailure),
      Email: () => fetchEmailsItemsV2(payload, fetchBegin, fetchSuccess, fetchFailure, packContentTypeSelectSelector),
      Message: () =>
        fetchMessagesItemsV2(payload, fetchBegin, fetchSuccess, fetchFailure, packContentTypeSelectSelector),
      ExternalEvent: () =>
        fetchEventsItemsV2(payload, fetchBegin, fetchSuccess, fetchFailure, packContentTypeSelectSelector),
      Pdf: () => fetchPdfsItemsV2(payload, fetchBegin, fetchSuccess, fetchFailure, packContentTypeSelectSelector),
      EmbeddedVideo: () =>
        fetchEmbeddedVideoItemsV2(payload, fetchBegin, fetchSuccess, fetchFailure, packContentTypeSelectSelector),
      Campaign: () =>
        fetchCampaignItemsV2(payload, fetchBegin, fetchSuccess, fetchFailure, packContentTypeSelectSelector),
      Link: () => fetchLinkItemsV2(payload, fetchBegin, fetchSuccess, fetchFailure, packContentTypeSelectSelector),
    };

    const context = packContentTypeSelectSelector(getState());

    if (!context || !map[context]) {
      return;
    } else {
      await dispatch(map[context]());
    }
  };
};
